import { render, staticRenderFns } from "./DslForm.vue?vue&type=template&id=a383c8ee&"
import script from "./DslForm.vue?vue&type=script&lang=js&"
export * from "./DslForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports